import View from './FlowBuilderGenerator.view';

export default View;
